import React from "react";
import LandingPageSideBar from "../../Components/Sidebar/LandingPageSideBar/LandingPageSideBar";
import Home from "../../Components/sections/LandingPageSections/Home";
import VirtualArborist from "../../Components/sections/LandingPageSections/VirtualArborist";
import HowItWorks from "../../Components/sections/LandingPageSections/HowItWorks";
import HeroBanner from "../../Components/sections/LandingPageSections/HeroBanner";
import TreeGuyPlatform from "../../Components/sections/LandingPageSections/TreeGuyPlatform";
import Footer from "../../Components/sections/LandingPageSections/Footer";

function LandingPage() {
  return (
    <div className="flex flex-col">
      <LandingPageSideBar />
      <div className="bg-white h-[80px] md:h-[96px]"></div>
      <div id="Home">
        <Home />
      </div>
      <div id="Connect with an Arborist">
        <VirtualArborist />
      </div>
      <div id="How It Works">
        <HowItWorks />
      </div>
      <HeroBanner />
      <div id="Cost of Tree Work">
        <TreeGuyPlatform />
      </div>
      <div id="Contact Us">
        <Footer />
      </div>
    </div>
  );
}

export default LandingPage;
